// style.js
import { styled } from '@mui/material/styles';
import { Button } from 'components/buttons';
import { FormRow as BaseFormRow } from 'components/styledComponents';

/* Upload button */
export const UploadButton = styled(Button)({
  width: '100%',
  height: '100%'
});

/* FlexBox container */
export const FlexBox = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

/* Text element (supports color prop with theme fallback) */
export const Text = styled('p')(({ theme, color }) => ({
  color: color || theme.color.primary.main,
  position: 'absolute',
  fontSize: theme.fontSize.small,
  margin: '5px 0'
}));

/* Reuse existing FormRow */
export const FormRow = styled(BaseFormRow)({
  margin: '10px 0'
});

/* Container for text elements */
export const TextContainer = styled('div')({
  position: 'relative'
});
